/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Proof_3_VInputs */

const en_mk_proof_3_v = /** @type {(inputs: Mk_Proof_3_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible costs`)
};

const id_mk_proof_3_v = /** @type {(inputs: Mk_Proof_3_VInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biaya terlihat`)
};

/**
* | output |
* | --- |
* | "Visible costs" |
*
* @param {Mk_Proof_3_VInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_proof_3_v = /** @type {((inputs?: Mk_Proof_3_VInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Proof_3_VInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_proof_3_v(inputs)
	return en_mk_proof_3_v(inputs)
});